import {ApiService} from "../index";
import {APIConfig} from "../../../constants";

const LoginAPICall = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.LOGIN.METHOD](APIConfig.LOGIN.URL, payload);
}

const CheckLoginAPICall = (token: string) => {
    // @ts-ignore
    return ApiService[APIConfig.CHECK_LOGIN.METHOD](APIConfig.CHECK_LOGIN.URL, {}, {Authorization: "Bearer " + token});
}

const LogoutAPICall = () => {
    // @ts-ignore
    return ApiService[APIConfig.LOGOUT.METHOD](APIConfig.LOGOUT.URL);
}

const ResumeSessionAPICall = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.VERIFY_PASSWORD.METHOD](APIConfig.VERIFY_PASSWORD.URL, payload);
}

const sendForgotPasswordEmail = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SEND_FORGOT_PASSWORD_MAIL.METHOD](APIConfig.SEND_FORGOT_PASSWORD_MAIL.URL, payload);
}

const UpdatePassword = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.UPDATE_PASSWORD.METHOD](APIConfig.UPDATE_PASSWORD.URL, payload);
}

const VerifySignature = (userId:string) => {
    // @ts-ignore
    return ApiService[APIConfig.VERIFY_SIGNATURE.METHOD](APIConfig.VERIFY_SIGNATURE.URL(userId));
}

const AddSignature = (userId:string,payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ADD_SIGNATURE.METHOD](APIConfig.ADD_SIGNATURE.URL(userId), payload);
}

const AccountService = {
    LoginAPICall,
    CheckLoginAPICall,
    LogoutAPICall,
    ResumeSessionAPICall,
    sendForgotPasswordEmail,
    UpdatePassword,
    VerifySignature,
    AddSignature
}

export default AccountService;
